import "@fontsource/heebo/400.css";
import "@fontsource/heebo/500.css";
import "@fontsource/heebo/700.css";
import "@fontsource/heebo/800.css";
import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initFirebase } from "./firebase";
import { MonitoringBoundary, initMonitoring } from "./monitoring";
import { RouterProvider } from "./router";
import { SessionProvider } from "./session";

initMonitoring();

const root = createRoot(document.getElementById("root") as HTMLElement);

const crashed = (
  <p className="fatal" role="alert">
    משהו השתבש בדף. נסו לרענן אותו בעוד רגע.
  </p>
);

try {
  await initFirebase();
  root.render(
    <StrictMode>
      <MonitoringBoundary fallback={crashed}>
        <RouterProvider>
          <SessionProvider>
            <App />
          </SessionProvider>
        </RouterProvider>
      </MonitoringBoundary>
    </StrictMode>,
  );
} catch {
  root.render(
    <p className="fatal" role="alert">
      האתר לא נטען כרגע. נסו לרענן את הדף בעוד רגע.
    </p>,
  );
}
